const apiUrls = require("../../constants/apiUrls");

const outletOptimizationDetails = {
  key: "outletOptimizationDetails",
  method: "GET",
  getApiUrl: (request) => {
    return `${apiUrls.CUSTOMER_OUTLET_OPTIMIZATION_URL}?accountNumber=${request.accountNumber}`;
  },
  dependencies: [
    {
      key: "orderDetails",
      requestProps: [
        {
          path: ["details", "accountNumber"],
          propName: "accountNumber",
        },
      ],
    },
  ],
};

export default outletOptimizationDetails;



// WEBPACK FOOTER //
// ./src/store/order-details-config/outletOptimizationDetails.js